import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type IMainErrorProps } from '../MainError/MainError';

interface ErrorBoundaryState {
    hasGlobalError: boolean;
    errorProps: IMainErrorProps | null;
}

const initialState: ErrorBoundaryState = {
    hasGlobalError: false,
    errorProps: null,
};

const errorBoundarySlice = createSlice({
    name: 'errorBoundary',
    initialState,
    reducers: {
        setGlobalError: (state, action: PayloadAction<IMainErrorProps>) => {
            state.hasGlobalError = true;
            state.errorProps = action.payload;
        },
        clearGlobalError: (state) => {
            state.hasGlobalError = false;
            state.errorProps = null;
        },
    },
});

export const { setGlobalError, clearGlobalError } = errorBoundarySlice.actions;
export default errorBoundarySlice.reducer;
